export default "__VITE_ASSET__7xZOmBAf__"